import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { RowLevelEnum } from './rowLevel.js';

export const TaskStatusSchema = z.enum(['pending', 'finished']);

export const TaskNameSchema = z.enum([
  'automapping',
  'create_tracker',
  'push_tracker',
]);

export const TaskOrderingSchema = z.enum(['created_at_desc']);

export const TaskStatsSchema = z.object({
  total: z.number().nullable(),
  success: z.number().nullable(),
  failed: z.number().nullable(),
});

export const TaskPathSchema = z.object({
  activityId: z.string(),
  platformId: z.string().nullable(),
  platformName: z.string().nullable(),
  mediaRowId: z.string().nullable(),
  campaignId: z.string().nullable(),
  campaignExternalId: z.string().nullable(),
  adGroupId: z.string().nullable(),
  adGroupExternalId: z.string().nullable(),
  adId: z.string().nullable(),
  adExternalId: z.string().nullable(),
});

export const TaskItemSchema = z.object({
  id: z.string(),
  settingsId: z.string(),
  taskId: z.string(),
  createdAt: z.string().nullish(),
  status: TaskStatusSchema,
  name: TaskNameSchema,
  level: RowLevelEnum,
  stats: TaskStatsSchema,
  path: TaskPathSchema,
});

export const TasksResponseSchema = createResponseSchema(TaskItemSchema);
